import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { 
  Users, Calendar, DollarSign, FileText, 
  ShoppingBag, BookOpen, Trophy, MessageSquare,
  Shield, Zap, Heart, Target 
} from "lucide-react";

export default function Features() {
  const features = [
    {
      icon: Users,
      title: "Member Management",
      description: "Manage PTA members, roles, and permissions with ease. Track attendance and engagement."
    },
    {
      icon: Calendar,
      title: "Event Planning",
      description: "Plan and coordinate events with ticketing, volunteer sign-ups, and resource management."
    },
    {
      icon: DollarSign,
      title: "Financial Management",
      description: "Track income, expenses, floats, and generate financial reports for transparency."
    },
    {
      icon: FileText,
      title: "Meeting Management",
      description: "Schedule meetings, track attendance, record minutes, and share with members."
    },
    {
      icon: ShoppingBag,
      title: "Affiliate Shop",
      description: "Earn commission through our Amazon affiliate shop featuring PTA-relevant products."
    },
    {
      icon: BookOpen,
      title: "Fundraising Library",
      description: "Access 100+ fundraising ideas with filters for season, location, and popularity."
    },
    {
      icon: Trophy,
      title: "Interactive Games",
      description: "Run digital raffles, guessing games, and bingo events to engage your community."
    },
    {
      icon: MessageSquare,
      title: "Communications",
      description: "Send emails to members and integrate with social media platforms."
    },
    {
      icon: Shield,
      title: "Asset Management",
      description: "Track PTA assets with loan system, payment processing, and overdue alerts."
    },
    {
      icon: Zap,
      title: "Catering Management",
      description: "Manage stock, pricing, allergen information, and event catering assignments."
    },
    {
      icon: Heart,
      title: "Community Engagement",
      description: "Templates for donations, sponsorships, and small business hire opportunities."
    },
    {
      icon: Target,
      title: "Goal Tracking",
      description: "Set and monitor fundraising goals with visual progress tracking and reporting."
    }
  ];

  return (
    <div className="space-y-8 animate-fade-in">
      <div className="text-center">
        <h1 className="text-4xl font-bold text-foreground mb-4">Features</h1>
        <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
          Everything your PTA needs to succeed, all in one powerful platform
        </p>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {features.map((feature, i) => {
          const Icon = feature.icon;
          return (
            <Card key={i} className="shadow-card hover:shadow-elevated transition-shadow">
              <CardHeader>
                <div className="flex items-center gap-3 mb-2">
                  <div className="p-2 rounded-lg bg-primary/10">
                    <Icon className="h-5 w-5 text-primary" />
                  </div>
                  <CardTitle className="text-lg">{feature.title}</CardTitle>
                </div>
              </CardHeader>
              <CardContent>
                <CardDescription>{feature.description}</CardDescription>
              </CardContent>
            </Card>
          );
        })}
      </div>

      <Card className="shadow-card bg-gradient-hero">
        <CardContent className="text-center py-8">
          <h2 className="text-2xl font-bold text-foreground mb-4">Ready to Experience These Features?</h2>
          <p className="text-muted-foreground mb-6 max-w-xl mx-auto">
            Start your free trial today and discover how PTA Hub can transform your PTA management
          </p>
          <div className="flex gap-4 justify-center">
            <Link to="/auth">
              <Button size="lg">Start Free Trial</Button>
            </Link>
            <Link to="/pricing">
              <Button size="lg" variant="outline">View Pricing</Button>
            </Link>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
